<template>
    <auth-layout>
        <container class="align-items-center min-vh-100">
            <row class="min-vh-100 justify-content-center align-items-center">
                <column md="6">
                    <card class="p-4 m-0 mt-5">
                        <c-form @submit.prevent="submit">
                            <h2>
                                {{
                                    trans(
                                        `auth.two_factor_challenge.${type}.heading`,
                                    )
                                }}
                            </h2>
                            <p class="text-muted">
                                <template>
                                    {{
                                        trans(
                                            `auth.two_factor_challenge.${type}.prompt`,
                                        )
                                    }}
                                </template>
                            </p>
                            <div v-if="!recovery">
                                <jet-input
                                    ref="code"
                                    v-model="form.code"
                                    :horizontal="false"
                                    :invalid-feedback="form.errors.code"
                                    :placeholder="
                                        trans(
                                            'auth.two_factor_challenge.placeholder.challenge',
                                        )
                                    "
                                    autocomplete="one-time-code"
                                    autofocus
                                    inputmode="numeric"
                                    required
                                    type="text"
                                >
                                    <template #prepend>
                                        <icon icon="cil-user" />
                                    </template>
                                </jet-input>
                            </div>

                            <div v-else>
                                <jet-input
                                    ref="recovery_code"
                                    v-model="form.recovery_code"
                                    :horizontal="false"
                                    :invalid-feedback="
                                        form.errors.recovery_code
                                    "
                                    :placeholder="
                                        trans(
                                            'auth.two_factor_challenge.placeholder.recovery_code',
                                        )
                                    "
                                    autocomplete="one-time-code"
                                    autofocus
                                    inputmode="numeric"
                                    required
                                    type="text"
                                >
                                    <template #prepend>
                                        <icon icon="cil-user" />
                                    </template>
                                </jet-input>
                            </div>
                            <div
                                class="d-flex justify-content-between flex-wrap"
                            >
                                <jet-button
                                    class="mb-2"
                                    color="secondary"
                                    @click.prevent="toggleRecovery"
                                >
                                    {{
                                        trans(
                                            `auth.two_factor_challenge.action.${type}`,
                                        )
                                    }}
                                </jet-button>
                                <jet-button
                                    :disabled="form.processing"
                                    class="px-4 mb-2"
                                    color="primary"
                                    type="submit"
                                    >{{
                                        trans(
                                            'auth.two_factor_challenge.action.submit',
                                        )
                                    }}
                                </jet-button>
                            </div>
                        </c-form>
                    </card>
                </column>
            </row>
        </container>
    </auth-layout>
</template>

<script>
import JetButton from '@/Jetstream/Button.vue';
import AuthLayout from '@/Layouts/AuthLayout.vue';
import JetInput from '@/Jetstream/Input.vue';
import Container from '@/Components/Container.vue';
import Row from '@/Components/Row.vue';
import Card from '@/Components/Card.vue';

export default {
    components: {
        Card,
        Row,
        Container,
        JetInput,
        JetButton,
        AuthLayout,
    },

    data() {
        return {
            recovery: false,
            form: this.$inertia.form({
                code: '',
                recovery_code: '',
            }),
        };
    },

    computed: {
        type() {
            return this.recovery ? 'recovery_code' : 'challenge';
        },
    },

    methods: {
        toggleRecovery() {
            this.recovery ^= true;

            this.$nextTick(() => {
                let container = this.$refs.code;

                if (this.recovery) {
                    container = this.$refs.recovery_code;
                    this.$refs.recovery_code.$el
                        .getElementsByTagName('input')[0]
                        .focus();

                    this.form.code = '';
                } else {
                    this.$refs.code.$el
                        .getElementsByTagName('input')[0]
                        .focus();

                    this.form.recovery_code = '';
                }

                container.$el.getElementsByTagName('input')[0].focus();
            });
        },

        submit() {
            this.form.post(this.route('two-factor.login'));
        },
    },
};
</script>
